<script setup>
import { ref, onMounted } from 'vue';
import { useScrollAnimations } from '@/composables/useScrollAnimations';
import LandingCtaButton from './LandingCtaButton.vue';


const { animateInView, slideLeft, slideRight } = useScrollAnimations();
const sectionRef = ref(null);
const leftColRef = ref(null);
const rightColRef = ref(null);

onMounted(() => {
    if (sectionRef.value) {
        animateInView(sectionRef.value, () => {
            // Animate container if needed, or columns individually
        });
    }
    if (leftColRef.value && rightColRef.value) {
        animateInView(leftColRef.value, () => {
            slideRight(leftColRef.value);
            slideLeft(rightColRef.value);
        });
    }
});
</script>

<template>
    <div class="py-24 relative" ref="sectionRef">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                <!-- Text Content (Left) -->
                <div ref="leftColRef" class="opacity-0">
                    <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6"
                        v-html="$t('landingPage.v2.finalCta.title')">
                    </h2>

                    <p class="text-lg text-white mb-8 leading-relaxed font-medium">
                        {{ $t('landingPage.v2.finalCta.lead') }}
                    </p>

                    <p class="text-gray-400 mb-10 leading-relaxed">
                        {{ $t('landingPage.v2.finalCta.text') }}
                    </p>

                    <div>
                        <LandingCtaButton sectionName="FinalCTA" :text="$t('landingPage.v2.cta.finalCta')" />
                    </div>
                </div>

                <!-- Image (Right) -->
                <div ref="rightColRef" class="opacity-0 relative">
                    <div
                        class="relative w-full aspect-square max-w-md mx-auto rounded-xl overflow-hidden bg-gray-900 border border-white/10 shadow-2xl flex items-center justify-center">
                        <!-- Background glow effect -->
                        <div class="absolute inset-0 bg-gradient-to-tr from-terciary/20 to-transparent opacity-40">
                        </div>

                        <!-- <img :src="threat.image" :alt="threat.title" class="object-cover w-full h-full" /> -->
                        <div class="text-white/20 text-4xl font-bold">IMAGE</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped></style>
